/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-24T15:57:51.84
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseTypeTag,
	listRentHouseTypeTagInit,
	listRentHouseTypeTagByAuthorizations,
	deleteRentHouseTypeTag
	
} from '@api/rentmanage/RentHouseTypeTag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseTypeTag({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeTag(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypeTagByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeTagByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypeTagInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeTagInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseTypeTag({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseTypeTag({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
